import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { formatINR, formatDateTime } from "@/lib/format";

interface Trade {
  _id: string;
  symbol: string;
  side: "BUY" | "SELL";
  qty: number;
  price: number;
  value: number;
  pnl?: number;
  mode: "REAL" | "VIRTUAL";
  strategy?: string;
  executedAt: string;
}

export default function Trades() {
  const { data: tradesResp, isLoading, error } = useQuery<{ data: Trade[]; total: number }>({
    queryKey: ["trades"],
    queryFn: () => api.get("/trades"),
  });
  const trades = tradesResp?.data ?? [];

  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 20 }}>
        Trade Journal
      </h1>

      <div className="card">
        {isLoading && <div style={{ padding: 20, color: "var(--text-muted)" }}>Loading trades…</div>}
        {error && <div style={{ padding: 20, color: "var(--red-light)" }}>Error: {error.message}</div>}
        {trades && trades.length === 0 && (
          <div style={{ padding: 20, color: "var(--text-muted)" }}>No trades recorded</div>
        )}
        {trades && trades.length > 0 && (
          <table>
            <thead>
              <tr>
                <th>Time</th>
                <th>Symbol</th>
                <th>Side</th>
                <th>Mode</th>
                <th style={{ textAlign: "right" }}>Qty</th>
                <th style={{ textAlign: "right" }}>Price</th>
                <th style={{ textAlign: "right" }}>Value</th>
                <th style={{ textAlign: "right" }}>P&L</th>
                <th>Strategy</th>
              </tr>
            </thead>
            <tbody>
              {trades.map((t) => (
                <tr key={t._id}>
                  <td style={{ fontSize: 12, color: "var(--text-muted)" }}>{formatDateTime(t.executedAt)}</td>
                  <td style={{ fontWeight: 600 }}>{t.symbol}</td>
                  <td style={{ color: t.side === "BUY" ? "var(--green-light)" : "var(--red-light)", fontWeight: 500 }}>
                    {t.side}
                  </td>
                  <td>
                    <span style={{
                      fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 4,
                      background: t.mode === "REAL" ? "var(--green)" : "var(--amber)", color: "#fff",
                    }}>
                      {t.mode}
                    </span>
                  </td>
                  <td style={{ textAlign: "right", fontFamily: "var(--font-mono)" }}>{t.qty}</td>
                  <td style={{ textAlign: "right", fontFamily: "var(--font-mono)" }}>{formatINR(t.price)}</td>
                  <td style={{ textAlign: "right", fontFamily: "var(--font-mono)" }}>{formatINR(t.value)}</td>
                  <td style={{
                    textAlign: "right", fontFamily: "var(--font-mono)",
                    color: t.pnl != null ? (t.pnl >= 0 ? "var(--green-light)" : "var(--red-light)") : "var(--text-muted)",
                  }}>
                    {t.pnl != null ? formatINR(t.pnl) : "—"}
                  </td>
                  <td style={{ fontSize: 12, color: "var(--text-muted)" }}>{t.strategy || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
